import { render, staticRenderFns } from "./favoriteStar.vue?vue&type=template&id=0e04c09b&"
import script from "./favoriteStar.vue?vue&type=script&lang=js&"
export * from "./favoriteStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports